import { PropsWithChildren, FC } from 'react'
import { Tag } from 'antd'
import styles from '@ProdWb/JobDetails/styles.css'

export const StatusTag: FC<
    PropsWithChildren<{
        tag: { color: string; title: string }
        isDisabled?: boolean
        dataTestTarget?: string
    }>
> = props => {
    const { tag, dataTestTarget } = props

    return (
        <Tag
            color={tag?.color}
            className={styles.tagStyle}
            data-test-target={dataTestTarget}
        >
            {tag?.title}
        </Tag>
    )
}
